module.exports = __webpack_public_path__ + "img/06.c6aa8046.png";